module.exports = __webpack_public_path__ + "img/customerImg1.6a6a20bf.png";